export default import.meta.ROLLDOWN_FILE_URL_2$LtLFQdS6IeO$uJxLxRJQ